export default "__VITE_ASSET__Bpbcmdhl__"